<div class="container">
  <div class="col-md-12 text-end">
    <a><button type="button" class="btn-actvtytp" (click)="quickSearch()">Quick Links</button></a>
    <a><button type="button" class="btn-actvtytp add-new" (click)="addNew()">Add New</button></a>
  </div>
  <div class="col-md-12 mb-5 empl-tptxt">
    <h3>Knowledge Bank</h3>
  </div>

  <form [formGroup]="searchKnowledgeForm">
    <div class="col-12">
      <div class="row">
        <div class="col-md-12 mt-5 d-flex justify-content-center empl-tptxt">
          <h3>How can we help you?</h3>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
          <div class="mb-3 col-md-3">
            <div class="search-container d-flex justify-content-center">
              <input type="text" class="form-control" formControlName="heading" (keyup.enter)="search()" />
              <i class="fa fa-search" (click)="search()"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-category-selector [module]="'NA'" [showSubcategorySelector]="false"
                           (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
    </form>
    <br>
    <div class="row">
        <div class="col-12 d-flex mt-4 justify-content-center acvtypglastbtn">
            <a><button type="button" class="btn" (click)="search()">Search</button></a>
            <a><button type="button" class="btn-discard" (click)="viewAll()">View All</button></a>
        </div>
    </div>
</div>
